import { useEffect } from "react";
import { uploadLogo } from "../../../services/Api/superadminService";
import {
  showToastError,
  showToastSuccess,
} from "../../../services/Toasts/toasts";
import { useSuperAdminCreateUserPartnerStore } from "../../../stores/superadmin/createUser";
import { getLogo } from "../../../services/Api/partnerService";

const AddLogo = ({ idPartner, closeModal, namePartner }: any) => {
  const { imgDownload, setImgDownload, forceCall, setForceCall } =
    useSuperAdminCreateUserPartnerStore();

  useEffect(() => {
    getLogo(idPartner)
      .then((res) => {
        setImgDownload(res.data.base64);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }, [idPartner, forceCall]);

  const handleUploadLogo = (logo: any) => {
    // handle upload logo
    const formData = new FormData();
    formData.append("logo", logo);

    uploadLogo(idPartner, formData)
      .then(() => {
        showToastSuccess("Le logo a bien été ajouté !");
        setImgDownload("");
        setForceCall(!forceCall);
      })
      .catch(() => showToastError("Une erreur est survenue."));
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
        <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[45%]">
          {/* Content */}
          <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full bg-white p-3 rounded-t-xl">
              <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <svg className="w-5 h-6 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Ajouter un logo pour {namePartner}
              </h4>
            </div>
            
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="flex flex-col justify-start items-start w-11/12 mb-6">
                <div className="w-full mb-6">
                  <label
                    htmlFor="logo"
                    className="text-md sm:text-lg my-2 block text-gray-700 font-medium"
                  >
                    Sélectionner un logo :
                  </label>
                  <div className="w-full p-4 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-200">
                    <input
                      type="file"
                      name="logo"
                      id="logo"
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length > 0) {
                          handleUploadLogo(e.target.files[0]);
                        }
                      }}
                      className="w-full cursor-pointer text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 transition-colors duration-200"
                    />
                    <p className="text-xs text-gray-500 mt-2">
                      Formats acceptés : PNG, JPG, JPEG, GIF (max 5MB)
                    </p>
                  </div>
                </div>

                {/* Aperçu du logo actuel */}
                <div className="w-full mb-4">
                  <label className="text-md sm:text-lg my-2 block text-gray-700 font-medium">
                    Logo actuel :
                  </label>
                  <div className="w-full p-4 border border-gray-200 rounded-lg bg-white">
                    {imgDownload ? (
                      <div className="flex flex-col items-center">
                        <img
                          src={`data:image/png;base64,${imgDownload}`}
                          alt="Logo actuel"
                          className="w-32 h-24 object-contain mb-3 rounded-lg shadow-sm"
                        />
                        <p className="text-sm text-gray-600 text-center">
                          Logo actuel du partenaire
                        </p>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center py-8">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <p className="text-sm text-gray-500 text-center">
                          Aucun logo actuellement défini
                        </p>
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-red-500 hover:text-white cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => {
                  closeModal();
                  setImgDownload("");
                }}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className="px-4 py-2 bg-green-600 hover:bg-green-700 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => closeModal()}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Valider
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default AddLogo;
